exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.overflow-on .cell {\r\n  overflow: visible;\r\n  overflow-x: visible;\r\n  overflow-y: visible;\n}\n.el-badge[type=\"primary\"] .el-badge__content {\r\n  background-color: #409eff;\n}\n.el-badge[type=\"success\"] .el-badge__content {\r\n  background-color: #67c23a;\n}\n.el-badge[type=\"warning\"] .el-badge__content {\r\n  background-color: #e6a23c;\n}\n.el-badge[type=\"danger\"] .el-badge__content {\r\n  background-color: #f56c6c;\n}\n.el-badge[type=\"info\"] .el-badge__content {\r\n  background-color: #909399;\n}\n.cell-img .cell {\r\n  line-height: 0;\n}\r\n", ""]);

// exports
